import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
const IconToContainer = styled(FontAwesomeIcon)`
  transform: ${props =>
    props.dir === 'true' ? 'rotate(180deg)' : 'rotate(0deg)'};
`
export default function IconTo({ direction, color, arrowIcon }) {
  return (
    <IconToContainer
      dir={direction}
      icon={arrowIcon ? faArrowLeft : faChevronRight}
      color={color}
    />
  )
}
IconTo.propTypes = {
  direction: PropTypes.string,
  color: PropTypes.string,
  arrowIcon: PropTypes.bool,
}
IconTo.defaultProps = {
  color: '#777777',
  arrowIcon: false,
}
